//Kolonat per librin e shitjes
//Perdoret per:
//*Librin e shitjes
//*Librin e Shpenzimeve
//*Librin blerjeve investive

export const salesColumns = ["Nr", "TransactionType", "Date", "InvoiceNr", "ActionType", "AccountName",
    "IdentificationNumber", "VATNumber", "Total", "Amount0", "Amount8", "VAT8", "Amount18", "VAT18", "FiscalYear"];

export const salesMappings = {
    Nr: "Numri",
    TransactionType: "Lloji Transaksionit",
    Date: "Data",
    InvoiceNr: "Numri Faturës",
    ActionType: "Lloji Faturës",
    AccountName: "Emri Llogarisë",
    IdentificationNumber: "Numri Identifikues",
    VATNumber: "Numri TVSH-s",
    Total: "Totali",
    Amount0: "Vlera 0",
    Amount8: "Vlera 8",
    VAT8: "TVSH 8",
    Amount18: "Vlera 18",
    VAT18: "TVSH 18",
    FiscalYear: "Viti Fiskal",
};

//Kolonat per librin e blerjes

export const purchaseColumns = ["Nr", "TransactionType", "Date", "InvoiceNr", "ImpInvoiceNr", "ActionType", "AccountName",
    "IdentificationNumber", "VATNumber", "Total", "Amount0", "Amount8", "VAT8", "Amount18", "VAT18", "FiscalYear"];

export const purchaseMappings = {
    Nr: "Numri",
    TransactionType: "Lloji Transaksionit",
    Date: "Data",
    InvoiceNr: "Numri Faturës",
    ImpInvoiceNr: "Numri i Dudit",
    ActionType: "Lloji Faturës",
    AccountName: "Emri Llogarisë",
    IdentificationNumber: "Numri Identifikues",
    VATNumber: "Numri TVSH-s",
    Total: "Totali",
    Amount0: "Vlera 0",
    Amount8: "Vlera 8",
    VAT8: "TVSH 8",
    Amount18: "Vlera 18",
    VAT18: "TVSH 18",
    FiscalYear: "Viti Fiskal",
};